<template>
	<div class="admin-main">
		<div class="admin-top flex-rcc">
			超级管理员信息
		</div>
		<van-form validate-first @submit="onSubmit" class="form-box">
			<div class="field-box">
				<van-field v-model="username" name="username" label="姓名" placeholder="请输入用户姓名" :rules="[{ required: true, message: '请填写用户名' }]"></van-field>
				<div class="remind">建议超级管理员是个体工商户或者公司法人</div>
			</div>
			<div class="field-box">
				<van-field v-model="card" name="card" label="身份证号" placeholder="请输入证件号码" :rules="[{ required: true, message: '请输入证件号码' }]"></van-field>
				<div class="remind">来往内地通行证、来往大陆通行证、护照等证件号码</div>
			</div>
			<div class="field-box">
				<van-field v-model="phone" name="phone" label="联系手机" placeholder="请输入联系手机号" :rules="[{ required: true, message: '请输入联系手机号' }]"></van-field>
			</div>
			<div class="field-box">
				<van-field v-model="email" name="email" label="联系邮箱" placeholder="请输入联系邮箱" :rules="[{ required: true, message: '请输入联系邮箱' }]"></van-field>
			</div>
		
			<div class="bottom-bar-placeholder"></div>
			<div class="admin-bottom-bar">
				<van-button native-type="submit" class="button-default" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" >
					下一步
				</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
  import { mapState } from 'vuex'
  import login from '../../util/login'
  export default {
    name: "index",
		data () {
      return{
        noBorder: false,
        username: '',
        card: '',
        phone: '',
        email: '',
			}
		},
    computed: {
      ...mapState(['isApp', 'openId'])
    },
    created () {
      console.log('isApp', this.isApp)
      this.$store.commit('userToken', '')
      this.getUserAgent()
    },
    methods: {
      getUserAgent () {
        let ua = navigator.userAgent.toLowerCase();
        console.log('ua', ua)
        let isAlipay = ua.indexOf("alipayclient") !== -1;
        window.isAlipay = isAlipay
        let isWeixin = ua.indexOf("micromessenger") !== -1;
        window.isWeixin = isWeixin
        if (window.isAlipay) {
          this.$store.commit('isApp', 'isAlipay')
        } else  if (window.isWeixin) {
          this.$store.commit('isApp', 'isWeixin')
        } else {
          console.log('H5只能在微信或支付宝用打卡！')
        }
        // this.getQuery()
        this.doLogin()
      },
      doLogin () {
        login().then((res) => { // res是微信登陆信息
          console.log('doLogin', res)
          const { userToken, openId } = res.data
          console.log('doLogin ------userToken', userToken)
          console.log('doLogin ------openId', openId)
          console.log('state ------userToken', this.$store.state.userToken)
        }).catch((err) => {
          this.$eventHub.$emit('authDone', {
            success: false,
            res: null,
            err: err
          })
        })
      },
			next () {},
      onSubmit(values) {
        console.log('submit', values)
      }
    }
  };
</script>

<style scoped lang="stylus">
	.van-cell
		padding 5px 2px !important
		&:after
			border none !important
			border-bottom 0 !important
</style>
